import { Button, Card, FormControl, FormLabel, Grid, Heading, Stack, Textarea } from '@chakra-ui/react'
import { useState } from 'react'

import { usePartner } from '@/context/PartnerContext'
import { InputGroup } from '../components/InputGroup'
import { Container } from '../components/ui/Container'
import { Section } from '../components/ui/Section'
import { FormRow } from '../containers/forms/FormRow'


export const InitMoveToBroker = ({ showBmwCallbackUrl = false }: { showBmwCallbackUrl?: boolean }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [token, setToken] = useState('')
  const [caseId, setCaseId] = useState<number | null>(null)
  const { currentPartner } = usePartner()

  const isBmw = currentPartner?.partner === 'BMWFS'
  const showCallbackField = isBmw || showBmwCallbackUrl

  const [callbackUrl, setCallbackUrl] = useState<string | null>(showCallbackField ? 'https://leosystem-bmwfs-test.cpd.assecods.pl' : null)

  const handleMoveToBroker = () => {
    setIsLoading(true)

    const req = new XMLHttpRequest()

    let url = `MoveToBroker/${caseId}`
    if (callbackUrl) {
      url += `?callbackUrl=${encodeURIComponent(callbackUrl!)}`
    }

    req.open('GET', url)
    req.setRequestHeader('Authorization', token)

    req.addEventListener('loadend', () => {
      setIsLoading(false)
      // window.open(req.responseURL, '_blank')
      window.open(req.responseURL)
      //window.location.replace(req.responseURL)
    })

    req.send()
  }

  return (
    <Card m={8}>
      <Section>
        <Container>
          <Stack direction='column' gap={4} mb={4}>
            <FormControl>
              <FormLabel>Token</FormLabel>
              <InputGroup as={Textarea} w='100%' colorScheme='blue' onChange={(e) => setToken(e.target.value)} />
            </FormControl>

            {showCallbackField &&
              <FormRow>
                <FormControl>
                  <FormLabel>callbackUrl</FormLabel>
                  <InputGroup sx={{ width: '100%' }} w='100%' htmlSize={60} value={callbackUrl!} onChange={(e) => setCallbackUrl(e.target.value)} />
                </FormControl>

                <FormControl>
                  <FormLabel>CaseId</FormLabel>
                  <InputGroup type='number' onChange={(e) => setCaseId(parseInt(e.target.value))} />
                </FormControl>
              </FormRow>
            }

            {!showCallbackField &&
              <FormControl>
                <FormLabel>CaseId</FormLabel>
                <InputGroup type='number' onChange={(e) => setCaseId(parseInt(e.target.value))} />
              </FormControl>
            }
          </Stack>
          <Grid
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              mt: 16
            }}
          >
            <Heading sx={{ fontSize: '2xl', fontWeight: 'medium' }} as="h2" onClick={handleMoveToBroker}>
              <Button isLoading={isLoading}>Přejít do srovnávače</Button>
            </Heading>
          </Grid>
        </Container>
      </Section >
    </Card>
  )
}